import PropTypes from 'prop-types';
import {useMemo} from 'react';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Separator, Text} from '../../../ui';
import BECOME_CREATOR_STATUSES from '../constants/becomeCreatorStatuses';
import css from '../styles/BecomeCreatorWidgetLayout.module.css';

const getButtonLayout = (becomeCreatorStatus, onBecomeCreatorClick) => {
  switch (becomeCreatorStatus) {
    case BECOME_CREATOR_STATUSES.INITIAL: {
      return (
        <div className={css.becomeCreatorButton}>
          <Button
            color={Button.COLOR.SECONDARY}
            height={Button.HEIGHT.SMALL}
            onClick={onBecomeCreatorClick}
          >
            <TextLocal id={'profile.become-a-content-creator'} />
          </Button>
        </div>
      );
    }
    case BECOME_CREATOR_STATUSES.PENDING: {
      return (
        <div className={css.pendingButtonBlock}>
          <div className={css.pendingButton}>
            <Button color={Button.COLOR.YELLOW} height={Button.HEIGHT.SMALL}>
              <TextLocal id={'profile.pending'} />
            </Button>
          </div>
          <div className={css.pendingButtonDescription}>
            <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_14}>
              <TextLocal id={'profile.your-request-is-pending'} />
            </Text>
          </div>
        </div>
      );
    }
    case BECOME_CREATOR_STATUSES.DECLINED: {
      return (
        <div className={css.declinedButtonBlock}>
          <div className={css.declinedButton}>
            <Button
              color={Button.COLOR.RED}
              height={Button.HEIGHT.SMALL}
              onClick={onBecomeCreatorClick}
            >
              <TextLocal id={'profile.canceled-request'} />
            </Button>
          </div>
          <div className={css.declinedButtonDescription}>
            <Text color={Text.COLOR.GREY} fontSize={Text.FONT_SIZE.SIZE_14}>
              <TextLocal id={'profile.your-request-has-been-canceled'} />
            </Text>
          </div>
        </div>
      );
    }
  }
};

const BecomeCreatorWidgetLayout = ({
  becomeCreatorStatus,
  onBecomeCreatorClick,
}) => {
  const rightWidgetPartNode = useMemo(() => {
    return getButtonLayout(becomeCreatorStatus, onBecomeCreatorClick);
  }, [becomeCreatorStatus, onBecomeCreatorClick]);

  return (
    <>
      <div className={css.widget}>
        <div className={css.leftWidgetBlock}>
          <div className={css.heading}>
            <Text
              color={Text.COLOR.PRIMARY}
              fontWeight={Text.FONT_WEIGHT.BOLD}
              fontSize={Text.FONT_SIZE.SIZE_18}
            >
              <TextLocal id={'profile.change-to-creator'} />
            </Text>
          </div>
          <div className={css.leftWidgetDescription}>
            <Text
              color={Text.COLOR.GREY}
              fontSize={Text.FONT_SIZE.SIZE_14}
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_21}
            >
              <TextLocal id={'profile.if-you-want-to-start-creating'} />
            </Text>
          </div>
        </div>
        {rightWidgetPartNode}
      </div>
      <Separator />
    </>
  );
};

BecomeCreatorWidgetLayout.propTypes = {
  onBecomeCreatorClick: PropTypes.func.isRequired,
  becomeCreatorStatus: PropTypes.oneOf(Object.values(BECOME_CREATOR_STATUSES)),
};

export default BecomeCreatorWidgetLayout;
